export default __webpack_public_path__ + "static/media/BASE.c0475d19.png";